import {NOTIFICATION, NOTIFICATIONONE} from '../actions/constant';

const INITIAL_STATE = {
    list: {},
    one: {}
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type){
        case NOTIFICATION:
            return {...state, list:action.payload.data};
        case NOTIFICATIONONE:
            return {...state, one:action.payload.data};
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_notification.js